import styled from "styled-components";

const StyledRelative = styled.div`
  position: relative;
  width: 100%;
`

export default StyledRelative;
